import { render, staticRenderFns } from "./CustomerLocks.vue?vue&type=template&id=31b65366&"
import script from "./CustomerLocks.vue?vue&type=script&lang=js&"
export * from "./CustomerLocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports